/** Professional muted fills for initials avatars (white text). */
export const AVATAR_BACKGROUND_HEX = [
	'#475569', // slate-600
	'#0f766e', // teal-700
	'#4f46e5', // indigo-600
	'#0e7490', // cyan-700
	'#047857', // emerald-700
	'#1d4ed8', // blue-700
	'#6d28d9', // violet-700
	'#9f1239', // rose-800
	'#b45309', // amber-700
	'#0369a1', // sky-700
	'#86198f', // fuchsia-800
	'#57534e', // stone-600
] as const;

/** @deprecated Prefer {@link AVATAR_BACKGROUND_HEX} — class names may be purged. */
export const AVATAR_BACKGROUND_CLASSES = [
	'bg-slate-600',
	'bg-teal-700',
	'bg-indigo-600',
	'bg-cyan-700',
	'bg-emerald-700',
	'bg-blue-700',
	'bg-violet-700',
	'bg-rose-800',
	'bg-amber-700',
	'bg-sky-700',
	'bg-fuchsia-800',
	'bg-stone-600',
] as const;

export function hashAvatarSeed(seed: string): number {
	let hash = 0;
	for (let i = 0; i < seed.length; i += 1) {
		hash = (hash * 31 + seed.charCodeAt(i)) | 0;
	}

	return Math.abs(hash);
}

function colorIndex(seed: string): number {
	const colors = AVATAR_BACKGROUND_HEX;
	return hashAvatarSeed(seed || '?') % colors.length;
}

/** Stable hex background for an initials avatar (inline style — not purged). */
export function avatarBackgroundHex(seed: string): string {
	const colors = AVATAR_BACKGROUND_HEX;
	return colors[colorIndex(seed)] ?? colors[0];
}

/** Stable Tailwind background class (prefer {@link avatarBackgroundHex} when scanning is uncertain). */
export function avatarBackgroundClass(seed: string): string {
	const colors = AVATAR_BACKGROUND_CLASSES;
	const color = colors[colorIndex(seed)] ?? colors[0];

	return `!${color}`;
}

export function avatarBackgroundStyle(seed: string): { backgroundColor: string } {
	return { backgroundColor: avatarBackgroundHex(seed) };
}

/** Up to two initials from a display name. */
export function initialsFromName(name: string): string {
	const parts = name.trim().split(/\s+/).filter(Boolean);
	if (parts.length === 0) {
		return '?';
	}
	if (parts.length === 1) {
		return parts[0].slice(0, 2).toUpperCase();
	}

	return `${parts[0][0] ?? ''}${parts[parts.length - 1][0] ?? ''}`.toUpperCase();
}
